module.exports = __webpack_public_path__ + "img/checklist-icon.69cb88d3.svg";